import { call, put } from "redux-saga/effects";

function* requestFunction(successFunction, ...args) {
  try {
    const response = yield call(...args);

    if (typeof response !== "undefined") { 
      if (typeof successFunction === "function") 
        yield put(successFunction(response)); 
    } 
  } catch (error) {
    console.log('error from request fn', error)
  }
}

export default requestFunction;
